import React from "react";
import styled from "styled-components";

// 타입 정의
interface Project {
  title: string;
  description: string;
  link?: string;
  technologies?: string[];
}

interface PortfolioProps {
  name: string;
  email: string;
  phone?: string;
  github?: string;
  linkedin?: string;
  projects: Project[];
}

const Container = styled.div`
  max-width: 768px;
  margin: 0 auto;
  padding: 1rem;
  font-family: sans-serif;
`;

const Header = styled.header`
  margin-bottom: 1.5rem;
`;

const Name = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
`;

const Contact = styled.p`
  font-size: 0.875rem;
  color: #555;
`;

const Link = styled.a`
  margin-right: 0.5rem;
  color: #1e90ff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Section = styled.section`
  margin-top: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const ProjectCard = styled.div`
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  margin-bottom: 1rem;
`;

const ProjectTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: bold;
`;

const ProjectDesc = styled.p`
  font-size: 0.875rem;
  color: #333;
`;

const Tech = styled.p`
  font-size: 0.75rem;
  color: #777;
  margin-top: 0.5rem;
`;

const PortfolioTemplete: React.FC<PortfolioProps> = ({
  name,
  email,
  phone,
  github,
  linkedin,
  projects,
}) => {
  return (
    <Container>
      <Header>
        <Name>{name}</Name>
        <Contact>{email} {phone && <>| {phone}</>}</Contact>
        <Contact>
          {github && <Link href={github}>GitHub</Link>}
          {linkedin && <Link href={linkedin}>LinkedIn</Link>}
        </Contact>
      </Header>

      <Section>
        <SectionTitle>Projects</SectionTitle>
        {projects.map((project, index) => (
          <ProjectCard key={index}>
            <ProjectTitle>{project.title}</ProjectTitle>
            <ProjectDesc>{project.description}</ProjectDesc>
            {project.link && <Link href={project.link}>View Project</Link>}
            {project.technologies && (
              <Tech>Tech: {project.technologies.join(', ')}</Tech>
            )}
          </ProjectCard>
        ))}
      </Section>
    </Container>
  );
};

const Portfolio = () => {
    return (
        <PortfolioTemplete
            name="홍길동"
            email="gildong@example.com"
            phone="010-1234-5678"
            github="https://github.com/gildong"
            linkedin="https://linkedin.com/in/gildong"
            projects={[
                {
                title: "My Blog",
                description: "개인 기술 블로그를 만들었습니다.",
                link: "https://myblog.com",
                technologies: ["React", "TypeScript", "Tailwind CSS"]
                },
                {
                title: "To-do App",
                description: "할 일 목록 앱입니다.",
                technologies: ["Vue", "Firebase"]
                }
            ]}
        />
    );
};

export default Portfolio;